/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useRef, useState } from "react";
import FrontHeader from "../shared/FrontHeader/FrontHeader";
import FrontFooter from "../shared/FrontFooter/FrontFooter";
import BannerHomepage from "./BannerHomepage";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import Fade from "react-reveal/Fade";
import StarRatingComponent from "react-star-rating-component";
import { NavLink, Link, useSearchParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Icon2 from "../../assets/images/icons/icon2.svg";
import Empty from "../../assets/images/appImages/category.png";
import AliceCarousel from "react-alice-carousel";
import { getImage, truncateCaractere, formatCurrency } from "../../utils/Utils";
import {
  useGetProductListQuery,
  useGetProductsEnAvantQuery,
} from "../../utils/api/product/product.api";
import { useLazyFavoriteByUserQuery } from "../../utils/api/favories/favorie.api";
import { useGetAllCategoryListQuery } from "../../utils/api/category/category.api";
import { usePagination, useSearch } from "../../utils/hooks";
import { ApiBaseUrl } from "../../utils/http";
import axios from "axios";
import { useAppSelector, useAppDispatch } from "../../redux/hook";
import Swal from "sweetalert2";
import { Color } from "../../utils/theme";
import { ProductItemsSkeleton } from "../user/ParcoursAchat/ParcoursAchat";
import { useGetVendeurByApiKeyQuery } from "../../utils/api/product/product.api";
import { VendeurApikey } from "../../utils/http";
import { AppLocalStorage } from "../../utils/storage";
import { onSetUserToken } from "../../redux/slice/User.slice";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import aboutImg from "../../assets/images/appImages/aboutimg.png";
import ReactPlayer from "react-player";
import vcover from "../../assets/images/appImages/vcover.png";
import {
  addCartProduct,
  getCartCount,
  getTotalAmount,
  removeCartItem,
  type CartItemType,
} from "../../redux/slice/useCartSlice";
import { FiShoppingCart } from "react-icons/fi";
import { TbAdjustmentsHorizontal } from "react-icons/tb";
import {
  getCardPriceDisplay,
  getDefaultCartVariation,
  getProductPromoRate,
  getUnitPriceForVariation,
  hasProductStock,
  needsSizePickerOnCard,
} from "../../utils/productPricing";
import { ChooseSizeModal } from "./ChooseSizeModal";

export const responsiveI = {
  0: { items: 2 },
  992: { items: 3 },
  1024: { items: 4 },
};

export const responsiveII = {
  0: { items: 2 },
  992: { items: 3 },
  1024: { items: 7 },
};

export const getVendeur = () => {
  const { data: vendeur } = useGetVendeurByApiKeyQuery(VendeurApikey);
  return vendeur;
};

const CategorieSkeleton = () => {
  return (
    <>
      {Array(4)
        .fill(4)
        .map((el, i) => (
          <div className="col-lg-3 col-md-3 mb-3 dis-flex" key={i}>
            <div className="item-stat-dashboad-view ">
              <div className="content-item-stat-dashboad-view mt-2">
                <Skeleton className="titre-item-stat-dashboad-view mb-2" width={`70%`} />
              </div>
              <div className="content-stat-dashboard-view">
                <div className="content-text-item-stat-dashboad-view">
                  <div className="icon-item-stat-dashboad-view">
                    <Skeleton className="chiffre-item-stat-dashboad-view mb-1" width={`70%`} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

const HomePage = () => {
  const dispatch = useAppDispatch();
  const Remember = AppLocalStorage.getItem("remember");
  const UserRemember: any = AppLocalStorage.getItem("user");

  const { limit, page } = usePagination(12);
  let [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("status");
  const { data = { results: [] }, isLoading } = useGetProductListQuery({ page, limit });
  const { data: produitsEnAvant } = useGetProductsEnAvantQuery({ page, limit });
  const { data: categories, isLoading: isLoadingCategorie } = useGetAllCategoryListQuery();

  React.useEffect(() => {
    if (status == "success") {
      Swal.fire({
        icon: "success",
        title: `Paiement effectué avec succès!`,
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 3000,
      });
    }
    if (status == "error") {
      Swal.fire({
        icon: "error",
        title: "Erreur est survenue lors du paiement !",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  }, [status]);

  React.useEffect(() => {
    if (Remember) {
      dispatch(onSetUserToken({ user: UserRemember?.user, token: UserRemember?.token }));
    }
  }, [Remember]);

  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content">
        <BannerHomepage />
        <div className="container-easy-market mb-5">
          <div className="container-category-display-mobile px-lg-3">
            <div className="pb-5 content-title-home-page">
              <div className="title-home-page-container">
                <Fade bottom>
                  <h3 className="title-home-page-theme text-center">Nos catégories de produits</h3>
                </Fade>
              </div>
            </div>
            <div className="row">{isLoadingCategorie && <CategorieSkeleton />}</div>
            <div className="container-list-category-product">
              <AliceCarousel
                mouseTracking
                responsive={responsiveII}
                autoPlayStrategy="default"
                controlsStrategy="alternate"
                autoPlay
                infinite
                keyboardNavigation
                autoPlayInterval={6000}
              >
                {categories?.results?.map((item) => (
                  <Fade bottom key={item.id}>
                    <Link
                      state={{ catgoryId: item?.id }}
                      className="link-footer link-footer-deco trans-0-2 d-block"
                      to={`/produits?categorie=${item?.slug}`}
                    >
                      <div className="category-product-accueil-item position-relative">
                        <div className="content-icon-category-product-accueil">
                          {item?.images ? (
                            <img
                              loading="lazy"
                              className="catgoryImg"
                              src={getImage(item?.images)}
                              alt={item?.slug}
                            />
                          ) : (
                            <img loading="lazy" src={Icon2} alt={item?.slug} />
                          )}
                        </div>
                        <div className="title-category-product-item-mobile">{item?.nom}</div>
                      </div>
                    </Link>
                  </Fade>
                ))}
              </AliceCarousel>
            </div>
          </div>

          {/* ── À propos ── */}
          <div className="about-us mt-5">
            <Fade bottom>
              <h3 className="title-home-page-theme text-center">Le shilajit, qu'est-ce que c'est ?</h3>
            </Fade>
            <div className="mt-4 who-we-are who-we-are-page">
              <div className="container">
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <div className="custom-content">
                      Le shilajit est une substance naturelle résineuse, de couleur noire ou brun foncé,
                      qui provient principalement des montagnes de l'Himalaya, mais également d'autres
                      régions montagneuses comme l'Altai, le Caucase ou le Tibet. <br />
                      Formée par la décomposition lente de matières organiques et végétales sur des siècles,
                      cette résine est largement utilisée en médecine traditionnelle,
                    </div>
                    <div className="pt-3 container-btn-accueil">
                      <NavLink className="btn btn-title-home-page" to="/a-propos-de-nous">
                        En savoir plus
                      </NavLink>
                    </div>
                  </div>
                  <div className="col-md-6 mb-4">
                    <div className="illustration-container">
                      <img loading="lazy" src={aboutImg} alt="image" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Bienfaits + vidéo ── */}
          <div className="my-5 mb-0 container-home-page-nos-produits">
            <div className="custom_blur__container py-5">
              <div className="mt-4 who-we-are who-we-are-page">
                <div className="container">
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <div className="illustration-container">
                        <ReactPlayer
                          className="custom-video video__player"
                          light={vcover}
                          controls
                          src="https://youtu.be/h7LWxHrr7N4"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <Fade bottom>
                        <h3 className="title-home-page-theme">Les bienfaits du shilajit</h3>
                      </Fade>
                      <div className="custom-content">
                        Le shilajit est reconnu pour ses nombreuses propriétés bénéfiques, notamment en
                        médecine traditionnelle comme l'ayurveda. Voici les principaux bienfaits qui lui
                        sont attribués :
                      </div>
                      <div className="pt-3 container-btn-accueil">
                        <NavLink className="btn btn-title-home-page" to="/a-propos-de-nous">
                          En savoir plus
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Nouveaux produits (carousel) ── */}
          <div className="container-home-page mb-3 my-5 container-home-page-nos-produits-carousel">
            <div className="pb-5 content-title-home-page">
              <div className="title-home-page-container">
                <Fade bottom>
                  <h3 className="title-home-page-theme text-center">Nouveaux produits</h3>
                </Fade>
              </div>
            </div>
            <div className="row">{isLoading && <ProductItemsSkeleton />}</div>
            <div>
              <AliceCarousel
                mouseTracking
                responsive={responsiveI}
                autoPlayStrategy="default"
                controlsStrategy="alternate"
                autoPlay
                infinite
                keyboardNavigation
                autoPlayInterval={6000}
              >
                {produitsEnAvant?.count && produitsEnAvant?.count > 0
                  ? produitsEnAvant?.results
                      ?.slice(Math.max(produitsEnAvant?.results?.length - 10, 0))
                      ?.map((produit, key) => (
                        <div
                          key={key}
                          className="col-product-item px-2"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <ProductItem item={produit} />
                        </div>
                      ))
                  : data?.results
                      ?.slice(Math.max(data?.results?.length - 10, 0))
                      ?.map((produit, key) => (
                        <div
                          key={key}
                          className="col-product-item product-item-carousel px-2"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <ProductItem item={produit} />
                        </div>
                      ))}
              </AliceCarousel>
            </div>
          </div>

          {/* ── Nos Produits (grille) ── */}
          <div className="container-home-page my-5 mb-0 container-home-page-nos-produits">
            <div className="content-title-home-page pb-5">
              <div className="title-home-page-container">
                <Fade bottom>
                  <h3 className="title-home-page-theme text-center">Nos Produits</h3>
                </Fade>
              </div>
            </div>
            <div className="container-list-product-home">
              <Row>
                {isLoading && <ProductItemsSkeleton />}
                {data?.results
                  ?.slice(Math.max(data?.results?.length - 12, 0))
                  ?.map((produit, key) => (
                    <Col
                      key={key}
                      sm={6}
                      xs={6}
                      md={4}
                      lg={3}
                      className="col-content-product-home mb-4 pb-4"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <div className="product-item-carousel">
                        <ProductItem item={produit} />
                      </div>
                    </Col>
                  ))}
              </Row>
            </div>
            <div className="content-btn-title-home-page flex-r">
              <Fade right>
                <NavLink to="/produits" className="btn btn-see-more-product">
                  Voir plus
                </NavLink>
              </Fade>
            </div>
          </div>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default HomePage;

/* ─────────────────────────────────────────────
   ProductItem
───────────────────────────────────────────── */
export const ProductItem = ({ item }: { item: any }) => {
  const { user, token } = useAppSelector((s) => s?.user);
  const dispatch = useAppDispatch();
  const Vendeur = getVendeur();
  const [showSizePicker, setShowSizePicker] = useState(false);

  const imgProd =
    item?.type === "taille_unique"
      ? item?.images?.[0]?.image
      : item?.variations?.[0]?.images?.[0]?.image ?? null;

  const config = { headers: { Authorization: `Bearer ${token}` } };

  const [findBySlug, { data, isLoading }] = useLazyFavoriteByUserQuery();

  React.useEffect(() => {
    if (user?.slug) findBySlug(user?.slug as string);
  }, [user]);

  const cartItems = useAppSelector((s: any) => s?.cart?.cartItems ?? []);
  const promoRate = getProductPromoRate(item);
  const priceDisplay = getCardPriceDisplay(item, Vendeur?.devise);
  const showSizePickerUI = needsSizePickerOnCard(item);
  const defaultVariation = getDefaultCartVariation(item);
  const cartVariations: any[] = defaultVariation ? [defaultVariation] : [];
  const prixFinal = getUnitPriceForVariation(item, defaultVariation, promoRate);

  const isInCart = (): boolean =>
    cartItems?.some(
      (cartItem: CartItemType) =>
        cartItem?.produit?.id === item?.id &&
        (cartItem?.variations?.[0]?.id ?? null) ===
          (cartVariations?.[0]?.id ?? null),
    ) ?? false;

  const getCartItemForProduct = (): CartItemType | undefined =>
    cartItems?.find(
      (cartItem: CartItemType) =>
        cartItem?.produit?.id === item?.id &&
        (cartItem?.variations?.[0]?.id ?? null) ===
          (cartVariations?.[0]?.id ?? null),
    );

  const inCart = !showSizePickerUI && isInCart();
  /* ── Favoris ── */
  const isFavorite = (id: any) => !!data?.find((x: any) => x?.produit?.id === id);

  const handleAddFavoris = (id: any) => {
    const favorie = data?.find((x: any) => x?.produit?.id === id);
    const fd = new FormData();
    fd.append("user", user?.id);
    fd.append("produit", id);
    if (favorie) {
      axios
        .delete(ApiBaseUrl + `/api/favoris/${favorie?.slug}`, config)
        .then(() => findBySlug(user?.slug as string));
    } else {
      axios
        .post(ApiBaseUrl + "/api/favoris/", fd, config)
        .then(() => findBySlug(user?.slug as string));
    }
  };

  const onToggleFavorite = (id: any) => {
    if (!user?.slug) {
      Swal.fire({
        icon: "info",
        title: `Veuilliez vous connecter pour ajouter un produit au favoris .`,
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 6000,
      });
    } else {
      handleAddFavoris(id);
    }
  };

  const openSizePicker = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowSizePicker(true);
  };

  const addToCartDirect = () => {
    if (!defaultVariation?.id && item?.variations?.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Variation indisponible",
        text: "Ce produit n'est pas disponible pour le moment.",
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    dispatch(
      addCartProduct({
        produit: item,
        prix: prixFinal,
        quantite: 1,
        stock: item?.stock,
        variations: cartVariations,
        vendeur: item?.vendeur?.id,
      }),
    );
    dispatch(getCartCount());
    dispatch(getTotalAmount());

    Swal.fire({
      icon: "success",
      iconColor: Color.success,
      confirmButtonColor: Color.success,
      title: "Produit ajouté au panier avec succès !",
      showConfirmButton: false,
      timer: 2000,
    });
  };

  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (isOutOfStock) return;

    if (showSizePickerUI) {
      openSizePicker(e);
      return;
    }

    if (inCart) {
      const cartItem = getCartItemForProduct();
      if (cartItem) {
        dispatch(removeCartItem(cartItem));
        dispatch(getCartCount());
        dispatch(getTotalAmount());
        Swal.fire({
          icon: "info",
          iconColor: Color.success,
          confirmButtonColor: Color.success,
          title: "Produit retiré du panier",
          showConfirmButton: false,
          timer: 2000,
        });
      }
      return;
    }

    addToCartDirect();
  };

  const isOutOfStock = !hasProductStock(item);

  return (
    <Fade bottom>
      <div className="product-item-container" style={{ flexGrow: 1 }}>
        <NavLink
          to={`/produit/${item?.slug}`}
          state={item}
          className="no-link w-100 product-item-card-link"
        >
          {/* ── Badges ── */}
          {priceDisplay.showMultipleSizesBadge && (
            <span className="statut-product-item">Plusieurs tailles</span>
          )}
          {item?.new === true ? (
            <span className="statut-product-item">Nouveau</span>
          ) : item?.stock == 0 ? (
            <span className="statut-product-rupture">Rupture de stock</span>
          ) : null}
          {(item?.categorie?.promotion?.is_active ||
            item?.sous_categorie?.promotion?.is_active ||
            item?.promotion?.is_active) &&
            !priceDisplay.showMultipleSizesBadge && (
            <span className="statut-product-item">
              Promo -{item?.categorie?.promotion?.taux ||
                item?.sous_categorie?.promotion?.taux ||
                item?.promotion?.taux}
              %
            </span>
          )}

          {/* ── Image ── */}
          <div className="content-img-product-item">
            <img
              loading="lazy"
              src={imgProd ? getImage(imgProd) : Empty}
              alt={item?.nom}
              className="img-product-item"
            />
          </div>

          {/* ── Infos ── */}
          <div className="container-body-product-item">
            <div className="content-element-body-product-item">
              <p className="name-product-item my-2 reduce_hg">
                {window.innerWidth < 720
                  ? truncateCaractere(item?.nom, 39)
                  : truncateCaractere(item?.nom, 72)}
              </p>
              <div className="content-price-product">
                <span
                  className={`price-product-item d-flex ${priceDisplay.startingFrom ? "price-product-item--from" : ""}`}
                >
                  {priceDisplay.display}
                </span>
                {priceDisplay.strikethrough && (
                  <span className="price-product-item-bare pb-3">
                    {priceDisplay.strikethrough}
                  </span>
                )}
              </div>
            </div>
          </div>
        </NavLink>

        <div className="product-item-card-actions">
          {isOutOfStock ? (
            <button
              type="button"
              className="btn btn-theme-outline w-100 product-item-card-btn product-item-card-btn--disabled"
              disabled
            >
              Rupture de stock
            </button>
          ) : showSizePickerUI ? (
            <button
              type="button"
              className="btn btn-theme-outline w-100 product-item-card-btn product-item-card-btn--choose-size"
              onClick={openSizePicker}
            >
              <TbAdjustmentsHorizontal />
              <span className="ps-2">Choisir la taille</span>
            </button>
          ) : (
            <button
              type="button"
              className={`btn w-100 product-item-card-btn ${
                inCart
                  ? "btn-theme product-item-card-btn--in-cart"
                  : "btn-theme product-item-card-btn--add-cart"
              }`}
              onClick={handleAddToCart}
            >
              <FiShoppingCart />
              <span className="ps-2">
                {inCart ? "Dans le panier" : "Ajouter au panier"}
              </span>
            </button>
          )}
        </div>

        {showSizePickerUI && (
          <ChooseSizeModal
            product={item}
            devise={Vendeur?.devise}
            imageUrl={imgProd}
            isOpen={showSizePicker}
            onClose={() => setShowSizePicker(false)}
          />
        )}

        {/* ── Favori (hors NavLink) ── */}
        <button
          disabled={isLoading}
          className="btn icon-fav-product"
          id={item?.id}
          aria-label="Ajouter au favoris"
          onClick={() => onToggleFavorite(item?.id)}
        >
          {isFavorite(item?.id) ? (
            <AiFillHeart style={{ color: "#E58924" }} />
          ) : (
            <AiOutlineHeart />
          )}
        </button>
      </div>
    </Fade>
  );
};

export const ProductItemSkeleton = () => {
  return (
    <>
      {Array(12)
        .fill(12)
        .map((item, i) => (
          <div className="col-product-item" key={i}>
            <div
              className="product-item-container"
              style={{ border: "1px solid #ebebeb", textAlign: "center" }}
            >
              <div className="content-img-product-item">
                <Skeleton className="img-product-item" />
              </div>
              <div className="content-btn-buy-product-item py-3">
                <Skeleton className="btn btn-buy-product-item bg-transparent" width={`50%`} />
              </div>
              <div className="text-center">
                <Skeleton className="price-product-item" width={`60%`} height={20} />
                <Skeleton className="name-prduct fs-15" width={`70%`} height={15} />
                <div className="content-rate-product">
                  <StarRatingComponent
                    name="rate2"
                    starCount={5}
                    value={0}
                    starColor="#000000"
                    emptyStarColor="#D4D6D5"
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};